import ChargeHelper from 'features/Charge/chargeHelper';
import KTFormInput, {
    KTFormInputType,
} from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import KTFormRichTextEditor from 'general/components/OtherKeenComponents/Forms/KTFormRichTextEditor';
import KTBSDropdown from 'general/components/OtherKeenComponents/KTBSDropdown';
import CustomDropdown2 from 'general/components/Others/CustomDropdown2';
import AppColors from 'general/constants/AppColors';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import miscHelper from 'general/helpers/miscHelper';
import Utils from 'general/utils/Utils';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useEffect, useMemo, useState } from 'react';

const styles = {
    avatarUploadContainer: {
        border: '2px dashed #cbd5e1',
        borderRadius: '12px',
        background: '#f8fafc',
        height: '180px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'all 0.2s ease',
        position: 'relative',
        overflow: 'hidden',
    },
    subImageUploadContainer: {
        border: '2px dashed #cbd5e1',
        borderRadius: '12px',
        background: '#f8fafc',
        minHeight: '180px',
        padding: '16px',
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(130px, 1fr))',
        gap: '12px',
        alignItems: 'start',
    },
    attributeRow: {
        background: '#f8fafc',
        border: '1px solid #e2e8f0',
        borderRadius: '10px',
        padding: '12px 16px',
        marginBottom: '10px',
        transition: 'all 0.2s ease-in-out',
        boxShadow: '0 1px 2px rgba(0,0,0,0.02)',
    },
    productBadgeList: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '10px',
    },
    productBadgeChip: {
        border: '1px solid #dbe3ef',
        background: '#fff',
        color: '#475569',
        borderRadius: '999px',
        padding: '7px 12px 7px 8px',
        fontWeight: 700,
        fontSize: '13px',
        display: 'inline-flex',
        alignItems: 'center',
        gap: '8px',
        cursor: 'pointer',
        transition: 'all 0.18s ease',
    },
    productBadgeIcon: {
        width: '28px',
        height: '28px',
        borderRadius: '999px',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        flex: '0 0 28px',
        fontSize: '13px',
    },
};

const productBadgeOptions = [
    { value: 'BEST_SELLER', label: 'Bán chạy', color: '#f97316', icon: 'fa-solid fa-fire' },
    { value: 'NEW', label: 'Mới', color: '#3b82f6', icon: 'fa-solid fa-sparkles' },
    { value: 'HOT', label: 'Hot', color: '#ef4444', icon: 'fa-solid fa-bolt' },
    { value: 'PROMOTION', label: 'Khuyến mãi', color: '#ec4899', icon: 'fa-solid fa-tags' },
    { value: 'FEATURED', label: 'Nổi bật', color: '#8b5cf6', icon: 'fa-solid fa-star' },
    { value: 'LIMITED', label: 'Giới hạn', color: '#0f766e', icon: 'fa-solid fa-clock' },
];

const defaultEditorConfig = {
    toolbar: {
        items: [
            'bold', 'italic', 'underline', 'strikethrough',
            '|',
            'fontFamily', 'fontSize',
            '|',
            'fontColor', 'fontBackgroundColor',
            '|',
            'subscript', 'superscript',
            '|',
            'heading',
            '|',
            'alignment',
            'outdent', 'indent',
            'bulletedList', 'numberedList',
            '|',
            'link', 'imageUpload',
            '|',
            'removeFormat',
            'sourceEditing',
            '|',
            'undo', 'redo',
        ],
        shouldNotGroupWhenFull: false,
    },
};

DialogChargeInventoryAddView.propTypes = {
    item: PropTypes.object,
    onCancel: PropTypes.func,
    onDone: PropTypes.func,
};

function DialogChargeInventoryAddView({ item, onCancel, onDone }) {
    // MARK: ---- PROPERTIES ----
    const editMode = !!item;
    const [loading, setLoading] = useState(false);
    const [readyToValidate, setReadyToValidate] = useState(false);
    const [avatarImage, setAvatarImage] = useState(null);
    const [subImages, setSubImages] = useState([]);
    const [name, setName] = useState('');
    const [slug, setSlug] = useState('');
    const [price, setPrice] = useState('');
    const [originalPrice, setOriginalPrice] = useState('');
    const [selectedChargeBrand, setSelectedChargeBrand] = useState(null);
    const [unit, setUnit] = useState('');
    const initialSpecs = (() => {
        let specs = item?.technicalSpecs || {};
        if (typeof specs === 'string') {
            try { specs = JSON.parse(specs); } catch (e) { specs = {}; }
        }
        
        // Auto-fill shortDescription if empty
        if (!specs.shortDescription && item) {
            let catName = typeof item.productCategory === 'object' ? item.productCategory?.name : item.productCategory;
            catName = catName || specs.shortName || '';
            let attrs = Array.isArray(item.productAttributes) ? item.productAttributes.filter(a => a?.value).slice(0, 2) : [];
            let generatedHtml = '';
            if (catName) {
                generatedHtml += `<p>${catName}</p>`;
            }
            if (attrs.length > 0) {
                generatedHtml += `<ul>${attrs.map(a => `<li>${a.value}</li>`).join('')}</ul>`;
            }
            specs.shortDescription = generatedHtml;
        }
        
        return specs;
    })();

    const [description, setDescription] = useState(item?.description || '');
    const [commissionRate, setCommissionRate] = useState('');
    const [productCategories, setProductCategories] = useState([]);
    const [productCategoryId, setProductCategoryId] = useState('');
    const [displayOrder, setDisplayOrder] = useState('');
    const [isVisible, setIsVisible] = useState(true);
    const [productBadges, setProductBadges] = useState([]);
    const [productAttributes, setProductAttributes] = useState([{ label: '', value: '' }]);
    const [draggedIndex, setDraggedIndex] = useState(null);
    const [technicalSpecs, setTechnicalSpecs] = useState({
        productCode: initialSpecs.productCode ?? '',
        shortName: initialSpecs.shortName ?? '',
        shortDescription: initialSpecs.shortDescription ?? '',
        category: initialSpecs.category ?? '',
        chargingLevel: initialSpecs.chargingLevel ?? '',
        mountType: initialSpecs.mountType ?? '',
        dimensions: initialSpecs.dimensions ?? '',
        input: initialSpecs.input ?? '',
        origin: initialSpecs.origin ?? '',
        voltage: initialSpecs.voltage ?? '',
        chargeMethod: initialSpecs.chargeMethod ?? '',
        connection: initialSpecs.connection ?? '',
        maxOutput: initialSpecs.maxOutput ?? '',
        socketOutput: initialSpecs.socketOutput ?? '',
        temperature: initialSpecs.temperature ?? '',
        humidity: initialSpecs.humidity ?? '',
        protocol: initialSpecs.protocol ?? '',
        weight: initialSpecs.weight ?? '',
        protection: initialSpecs.protection ?? '',
        features: initialSpecs.features ?? '',
        note: initialSpecs.note ?? '',
    });

    const handleDragStart = (e, index) => {
        setDraggedIndex(index);
        e.dataTransfer.effectAllowed = 'move';
    };

    const handleDragOver = (e, index) => {
        e.preventDefault();
        if (draggedIndex === null || draggedIndex === index) return;
        const next = [...productAttributes];
        const draggedItem = next[draggedIndex];
        next.splice(draggedIndex, 1);
        next.splice(index, 0, draggedItem);
        setDraggedIndex(index);
        setProductAttributes(next);
    };

    const handleDragEnd = () => {
        setDraggedIndex(null);
    };

    const handleChangeSpec = (key, value) => {
        setTechnicalSpecs((prev) => ({
            ...prev,
            [key]: value,
        }));
    };

    const normalizeMultiline = (value) => {
        if (_.isArray(value)) {
            return value.join('\n');
        }
        return value ?? '';
    };

    const buildTechnicalSpecsPayload = () => {
        const payload = {
            ...initialSpecs,
            ...technicalSpecs,
            productBadges,
            protection: normalizeMultiline(technicalSpecs.protection)
                .split('\n')
                .map((item) => item.trim())
                .filter(Boolean),
            features: normalizeMultiline(technicalSpecs.features)
                .split('\n')
                .map((item) => item.trim())
                .filter(Boolean),
        };
        return _.pickBy(payload, (value) => (_.isArray(value) ? value.length > 0 : value !== null && value !== undefined && value !== ''));
    };

    const normalizeAttributes = (attributes) => (attributes || [])
        .map((attr) => ({
            label: String(attr?.label || '').trim(),
            value: String(attr?.value || '').trim(),
        }))
        .filter((attr) => attr.label || attr.value);

    const updateAttribute = (index, key, value) => {
        setProductAttributes((current) => current.map((attr, attrIndex) => (
            attrIndex === index ? { ...attr, [key]: value } : attr
        )));
    };

    const addAttribute = () => setProductAttributes((current) => [...current, { label: '', value: '' }]);

    const removeAttribute = (index) => {
        setProductAttributes((current) => {
            const next = current.filter((_, attrIndex) => attrIndex !== index);
            return next.length ? next : [{ label: '', value: '' }];
        });
    };

    const toggleProductBadge = (badgeValue) => {
        setProductBadges((current) => (
            current.includes(badgeValue)
                ? current.filter((item) => item !== badgeValue)
                : [...current, badgeValue]
        ));
    };

    const normalizeImages = (value) => {
        let images = value;
        if (_.isString(images)) {
            try {
                images = JSON.parse(images);
            } catch (error) {
                images = [images];
            }
        }
        if (!_.isArray(images)) images = images ? [images] : [];
        return images.filter(Boolean).map((image) => ({
            url: _.isObject(image) ? (image.relativePath || image.path || image.url || '') : image,
            preview: Utils.getFullUrl(_.isObject(image) ? (image.relativePath || image.path || image.url || '') : image),
            file: null,
        })).filter((image) => image.url);
    };

    const addAvatarImage = (files) => {
        const file = Array.from(files || []).find((file) => file.type?.startsWith('image/'));
        if (file) {
            setAvatarImage({ file, url: '', preview: URL.createObjectURL(file) });
        }
    };

    const removeAvatarImage = () => setAvatarImage(null);

    const addSubImages = (files) => {
        const selectedFiles = Array.from(files || []).filter((file) => file.type?.startsWith('image/'));
        setSubImages((current) => [
            ...current,
            ...selectedFiles.map((file) => ({ file, url: '', preview: URL.createObjectURL(file) })),
        ]);
    };

    const removeSubImage = (index) => setSubImages((current) => current.filter((_, imageIndex) => imageIndex !== index));

    const moveSubImage = (index, direction) => setSubImages((current) => {
        const targetIndex = index + direction;
        if (targetIndex < 0 || targetIndex >= current.length) return current;
        const next = [...current];
        [next[index], next[targetIndex]] = [next[targetIndex], next[index]];
        return next;
    });

    useEffect(() => {
        ChargeHelper.API.requestGetProductCategoryList({ page: 0, limit: 100 })
            .then((response) => setProductCategories(response?.categories || []));
            
        if (!item) {
            ChargeHelper.API.requestGetChargeInventoryCategoryList({ page: 0, limit: 1 })
                .then((response) => {
                    const total = response?.total || 0;
                    setDisplayOrder(total + 1);
                });
        }
    }, [item]);

    useEffect(() => {
        if (item) {
            let itemSpecs = item?.technicalSpecs || {};
            if (_.isString(itemSpecs)) {
                try {
                    itemSpecs = JSON.parse(itemSpecs);
                } catch (error) {
                    itemSpecs = {};
                }
            }
            const imgs = normalizeImages(item.images);
            if (imgs.length > 0) {
                setAvatarImage(imgs[0]);
                setSubImages(imgs.slice(1));
            } else {
                setAvatarImage(null);
                setSubImages([]);
            }
            setName(item.name ?? '');
            setSlug(item.slug || '');
            setPrice(item.price ?? '');
            setOriginalPrice(item.originalPrice ?? '');
            setDescription(item.description ?? '');
            setCommissionRate(item.commissionRate ?? '');
            setUnit(item.unit ?? '');
            setProductCategoryId(item.productCategoryId ?? '');
            setDisplayOrder(item.displayOrder ?? '');
            setIsVisible(item.isVisible !== false);
            setProductBadges(_.isArray(item.productBadges)
                ? item.productBadges
                : (_.isArray(itemSpecs?.productBadges) ? itemSpecs.productBadges : []));
            const attrs = _.isArray(item.productAttributes) ? item.productAttributes : [];
            setProductAttributes(attrs.length ? attrs : [{ label: '', value: '' }]);
            setTechnicalSpecs({
                productCode: itemSpecs?.productCode ?? '',
                shortName: itemSpecs?.shortName ?? '',
                shortDescription: itemSpecs?.shortDescription || item.description || '',
                category: itemSpecs?.category ?? '',
                chargingLevel: itemSpecs?.chargingLevel ?? '',
                mountType: itemSpecs?.mountType ?? '',
                dimensions: itemSpecs?.dimensions ?? '',
                input: itemSpecs?.input ?? '',
                origin: itemSpecs?.origin ?? '',
                voltage: itemSpecs?.voltage ?? '',
                chargeMethod: itemSpecs?.chargeMethod ?? '',
                connection: itemSpecs?.connection ?? '',
                maxOutput: itemSpecs?.maxOutput ?? '',
                socketOutput: itemSpecs?.socketOutput ?? '',
                temperature: itemSpecs?.temperature ?? '',
                humidity: itemSpecs?.humidity ?? '',
                protocol: itemSpecs?.protocol ?? '',
                weight: itemSpecs?.weight ?? '',
                protection: normalizeMultiline(itemSpecs?.protection),
                features: normalizeMultiline(itemSpecs?.features),
                note: itemSpecs?.note ?? '',
            });
            setSelectedChargeBrand(item?.chargeBrand?.brandId ? {
                id: item.chargeBrand.brandId,
                name: item.chargeBrand.name,
                item: item.chargeBrand,
            } : null);
        }
    }, [item]);

    // MARK: ---- FUNCTIONS ----
    const handleSubmit = async () => {
        setReadyToValidate(true);
        const missingBaseInformation = !Utils.isValid(name) ||
            !Utils.isValid(price) ||
            !Utils.isValid(unit);
        const missingCreateInformation = !editMode && (
            !avatarImage ||
            !Utils.isValid(slug) ||
            !selectedChargeBrand ||
            !Utils.isValid(productCategoryId) ||
            !Utils.isValid(technicalSpecs?.shortDescription) ||
            !Utils.isValid(description)
        );
        if (missingBaseInformation || missingCreateInformation) {
            ToastHelper.showError('Vui lòng nhập đầy đủ thông tin');
            return;
        }

        if (Utils.isValid(price) && price <= 0) {
            ToastHelper.showError('Giá sản phẩm phải lớn hơn 0');
            return;
        }
        let params = {
            name,
            slug,
            brandId: selectedChargeBrand?.id ?? '',
            productCategoryId,
            price,
            originalPrice,
            unit,
            description,
            commissionRate,
            technicalSpecs: buildTechnicalSpecsPayload(),
            productAttributes: normalizeAttributes(productAttributes),
            productBadges,
            displayOrder,
            isVisible,
        };
        
        try {
            setLoading(true);
            let avatarUrl = '';
            if (avatarImage) {
                if (avatarImage.file) {
                    const res = await miscHelper.callApiUploadFile(avatarImage.file);
                    avatarUrl = _.isArray(res) && res.length > 0 ? res[0].relativePath : '';
                } else {
                    avatarUrl = avatarImage.url;
                }
            }
            
            const uploadedSubImages = await Promise.all(subImages.map(async (image) => {
                if (!image.file) return image.url;
                const res = await miscHelper.callApiUploadFile(image.file);
                return _.isArray(res) && res.length > 0 ? res[0].relativePath : '';
            }));
            
            params.images = [avatarUrl, ...uploadedSubImages].filter(Boolean);
            params = _.pickBy(params, (value, key) => value !== null && value !== undefined && (value !== '' || key === 'slug'));
            
            if (!editMode) {
                const res = await ChargeHelper.API.requestCreateChargeInventoryCategory(params);
                if (_.isBoolean(res) && res) {
                    ToastHelper.showSuccess('Thêm mới sản phẩm thành công');
                    onDone && onDone();
                } else if (_.isString(res)) {
                    ToastHelper.showError(res);
                }
            } else {
                const res = await ChargeHelper.API.requestUpdateChargeInventoryCategory(item.categoryId, params);
                if (_.isBoolean(res) && res) {
                    ToastHelper.showSuccess('Chỉnh sửa thông tin sản phẩm thành công');
                    onDone && onDone();
                } else if (_.isString(res)) {
                    ToastHelper.showError(res);
                }
            }
        } catch (error) {
            console.error(error);
            ToastHelper.showError('Lỗi kết nối. Vui lòng kiểm tra lại mạng hoặc thử lại sau!');
        } finally {
            setLoading(false);
        }
    };

    const dropdownChargeBrandEl = useMemo(() => {
        return (
            <CustomDropdown2
                id="brandId_dialog"
                name="brandId_dialog"
                ignoreConfirmClick={true}
                toggleElement={
                    <button
                        className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between ${readyToValidate && !selectedChargeBrand ? 'border-danger text-danger' : ''}`}
                        type="button"
                    >
                        {selectedChargeBrand?.name ?? 'Chọn hãng sản xuất'}
                    </button>
                }
                selectedValue={selectedChargeBrand}
                dropdownMenuItems={[{ name: 'Hãng sản xuất', role: 'CHARGE_BRAND' }]}
                getSubItems={async (item) => {
                    return ChargeHelper.API.requestGetChargeBrandList({
                        page: item?.page || 0,
                        limit: 10,
                        q: item?.q || '',
                    }).then((data) => {
                        return {
                            values: data.brands?.map((row) => ({
                                id: row?.brandId,
                                name: row?.name,
                                item: row,
                            })),
                            total: data.total,
                        };
                    });
                }}
                dropdownMenuStyle={{ maxHeight: '30vh' }}
                dropdownMenuClassName="overflow-auto w-100"
                onChange={(value) => {
                    setSelectedChargeBrand(value);
                }}
                isDropdownForm={true}
                titleSearchable={true}
                searchable={true}
                searchFormClassName="mx-3 my-1 search-form-border"
                defaultValue={{
                    name: 'Hãng sản xuất',
                    role: 'CHARGE_BRAND',
                }}
                footerEl={
                    <div
                        className="p-4 position-sticky sticky-bottom bg-white"
                        style={{
                            borderTop: `1px solid ${AppColors.gray[300]}`,
                        }}
                    >
                        {UIHelper.buildNegativeButton('Bỏ chọn', () => {
                            setSelectedChargeBrand(null);
                        })}
                    </div>
                }
            />
        );
    }, [selectedChargeBrand, readyToValidate]);

    return (
        <div className="d-flex flex-column" style={{ height: '85vh' }}>
            <div className="row m-0 p-0 px-2 mt-4 flex-grow-1 overflow-auto">
                {/* 1. Media Section */}
                <div className="col-12 mb-4 px-2">
                    <div className="row">
                        {/* Avatar Image */}
                        <div className="col-md-4 mb-4 d-flex flex-column position-relative">
                            <div className="d-flex align-items-center justify-content-between mb-2">
                                <div>{UIHelper.buildFormLabel('Ảnh đại diện sản phẩm', true)}</div>
                                <div className="btn btn-sm mb-0 p-0" style={{ visibility: 'hidden' }}>&nbsp;</div>
                            </div>
                            <div style={{ ...styles.avatarUploadContainer, flex: 1, minHeight: '180px' }}>
                                {avatarImage ? (
                                    <>
                                        <img src={avatarImage.preview} alt="Ảnh đại diện" style={{ width: '100%', height: '100%', maxHeight: '156px', objectFit: 'contain' }} />
                                        <button type="button" className="btn btn-xs btn-danger position-absolute" style={{ right: 8, top: 8 }} onClick={removeAvatarImage} title="Xóa ảnh">
                                            <i className="fa-regular fa-trash-can" />
                                        </button>
                                    </>
                                ) : (
                                    <label className="w-100 h-100 d-flex flex-column align-items-center justify-content-center m-0" style={{ cursor: 'pointer' }}>
                                        <div className="text-muted d-flex flex-column align-items-center">
                                            <i className="fa-solid fa-cloud-arrow-up fs-2x mb-2 text-primary" />
                                            <span className="fw-bold text-primary">Chọn ảnh sản phẩm</span>
                                        </div>
                                        <input type="file" accept="image/png,image/jpeg,image/jpg,image/webp" className="d-none" onChange={(event) => { addAvatarImage(event.target.files); event.target.value = ''; }} />
                                    </label>
                                )}
                            </div>
                            {readyToValidate && !avatarImage && (
                                <div className="invalid-feedback d-block position-absolute text-nowrap" style={{ bottom: '-20px', left: '10px' }}>
                                    Vui lòng thêm ảnh đại diện sản phẩm
                                </div>
                            )}
                        </div>

                        {/* Sub Images */}
                        <div className="col-md-8 mb-4 d-flex flex-column">
                            <div className="d-flex align-items-center justify-content-between mb-2">
                                <div>{UIHelper.buildFormLabel('Ảnh phụ sản phẩm')}</div>
                                <label className="btn btn-sm btn-light-primary mb-0 d-flex align-items-center justify-content-center">
                                    <i className="fa-solid fa-images mr-2" />
                                    <span>Thêm ảnh phụ</span>
                                    <input type="file" multiple accept="image/png,image/jpeg,image/jpg,image/webp" className="d-none" onChange={(event) => { addSubImages(event.target.files); event.target.value = ''; }} />
                                </label>
                            </div>
                            <div style={{ ...styles.subImageUploadContainer, flex: 1, minHeight: '180px' }}>
                                {subImages.length > 0 ? (
                                    subImages.map((image, index) => (
                                        <div key={`${image.preview}-${index}`} className="border rounded bg-light position-relative overflow-hidden" style={{ height: 156 }}>
                                            <img src={image.preview} alt={`Ảnh phụ ${index + 1}`} style={{ width: '100%', height: 110, objectFit: 'cover' }} />
                                            <div className="d-flex justify-content-center p-2 bg-white" style={{ gap: 6 }}>
                                                <button type="button" className="btn btn-xs btn-light" disabled={index === 0} onClick={() => moveSubImage(index, -1)} title="Chuyển sang trái"><i className="fa-solid fa-arrow-left" /></button>
                                                <button type="button" className="btn btn-xs btn-light" disabled={index === subImages.length - 1} onClick={() => moveSubImage(index, 1)} title="Chuyển sang phải"><i className="fa-solid fa-arrow-right" /></button>
                                                <button type="button" className="btn btn-xs btn-light-danger" onClick={() => removeSubImage(index)} title="Xóa ảnh"><i className="fa-regular fa-trash-can" /></button>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <div className="d-flex align-items-center justify-content-center w-100 text-muted" style={{ gridColumn: '1 / -1', minHeight: '148px' }}>
                                        Chưa có ảnh phụ
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                {/* 2. Basic Info Section */}
                {/* name */}
                <div className="col-md-6 mb-4 px-2">
                    {UIHelper.buildFormLabel('Tên sản phẩm', true)}
                    <KTFormInput
                        type={KTFormInputType.text}
                        placeholder="Nhập tên sản phẩm"
                        name="name"
                        value={name}
                        onChange={(value) => {
                            setName(value);
                        }}
                        enableCheckValid={readyToValidate}
                        isValid={Utils.isValid(name)}
                        isTouched={readyToValidate}
                        feedbackText={readyToValidate && !Utils.isValid(name) ? "Tên sản phẩm không hợp lệ" : ''}
                    />
                </div>
                <div className="col-md-6 mb-4 px-2">
                    {UIHelper.buildFormLabel('Đường dẫn SEO (Slug)', true)}
                    <KTFormInput
                        type={KTFormInputType.text}
                        placeholder="VD: san-pham-a"
                        name="slug"
                        value={slug}
                        onChange={(value) => {
                            setSlug(value);
                        }}
                        enableCheckValid={readyToValidate}
                        isValid={Utils.isValid(slug)}
                        isTouched={readyToValidate}
                        feedbackText={readyToValidate && !Utils.isValid(slug) ? "Vui lòng nhập đường dẫn SEO" : ''}
                    />
                </div>
                <div className="col-md-12 mb-4 px-2">
                    {UIHelper.buildFormLabel('Mô tả ngắn', true)}
                    <KTFormRichTextEditor
                        name="shortDescription"
                        data={technicalSpecs.shortDescription || ''}
                        variant="compact"
                        minHeight={120}
                        placeholder="Để hiển thị ở dưới mỗi tiêu đề sản phẩm"
                        onChange={(value) => {
                            handleChangeSpec('shortDescription', value);
                        }}
                        fieldMeta={readyToValidate && !Utils.isValid(technicalSpecs?.shortDescription) ? { error: 'Vui lòng nhập mô tả ngắn', touched: true } : {}}
                    />
                </div>
                {/* brandId */}
                <div className="col-md-4 mb-4 px-2">
                    {UIHelper.buildFormLabel('Hãng sản xuất', true)}
                    {dropdownChargeBrandEl}
                    {readyToValidate && !selectedChargeBrand && <div className="invalid-feedback d-block mt-1">Vui lòng chọn hãng sản xuất</div>}
                </div>
                <div className="col-md-4 mb-4 px-2">
                    {UIHelper.buildFormLabel('Danh mục sản phẩm', true)}
                    <select
                        className={`form-control ${readyToValidate && !Utils.isValid(productCategoryId) ? 'is-invalid' : ''}`}
                        value={productCategoryId}
                        onChange={(event) => setProductCategoryId(event.target.value)}
                    >
                        <option value="">Chọn danh mục sản phẩm</option>
                        {productCategories.map((category) => (
                            <option key={category.productCategoryId} value={category.productCategoryId}>
                                {category.name}
                            </option>
                        ))}
                    </select>
                    {readyToValidate && !Utils.isValid(productCategoryId) && <div className="invalid-feedback d-block">Vui lòng chọn danh mục sản phẩm</div>}
                </div>
                <div className="col-md-4 mb-4 px-2">
                    {UIHelper.buildFormLabel('Trạng thái')}
                    <div className="d-flex align-items-center" style={{ height: '38px' }}>
                        <label className="d-flex align-items-center gap-2 mb-0 cursor-pointer" style={{ fontWeight: 600, fontSize: '13px' }}>
                            <input
                                type="checkbox"
                                checked={isVisible}
                                onChange={(event) => setIsVisible(event.target.checked)}
                                style={{ width: '18px', height: '18px', cursor: 'pointer', margin: 0 }}
                            />
                            Hiển thị
                        </label>
                    </div>
                </div>
                <div className="col-md-12 mb-4 px-2">
                    <div style={styles.productBadgeList}>
                        {productBadgeOptions.map((badge) => {
                            const isSelected = productBadges.includes(badge.value);
                            return (
                                <button
                                    key={badge.value}
                                    type="button"
                                    style={{
                                        ...styles.productBadgeChip,
                                        ...(isSelected ? {
                                            borderColor: badge.color,
                                            background: `${badge.color}14`,
                                            color: badge.color,
                                            boxShadow: `0 8px 18px ${badge.color}18`,
                                        } : {}),
                                    }}
                                    onClick={() => toggleProductBadge(badge.value)}
                                >
                                    <span
                                        style={{
                                            ...styles.productBadgeIcon,
                                            color: badge.color,
                                            background: `${badge.color}18`,
                                        }}
                                    >
                                        <i className={badge.icon} />
                                    </span>
                                    {badge.label}
                                    {isSelected && <i className="fa-solid fa-check" />}
                                </button>
                            );
                        })}
                    </div>
                </div>

                {/* 3. Pricing & Commission Section */}
                <div className="col-12 mb-3 mt-2 px-2">
                    <div className="font-weight-bold d-flex align-items-center gap-2" style={{ fontSize: 16 }}>
                        <i className="fa-solid fa-coins text-primary" /> Thông tin giá cả & Hoa hồng
                    </div>
                </div>
                {/* price */}
                <div className="col-md-3 mb-4 px-2">
                    {UIHelper.buildFormLabel('Đơn giá (giá bán)', true)}
                    <KTFormInput
                        type={KTFormInputType.currency}
                        unit='VNĐ'
                        placeholder="Nhập giá sản phẩm"
                        name="price"
                        value={price}
                        onChange={(value) => {
                            setPrice(value);
                        }}
                        enableCheckValid={readyToValidate}
                        isValid={
                            Utils.isValid(price) && price > 0
                        }
                        isTouched={readyToValidate}
                        feedbackText={readyToValidate && (!Utils.isValid(price) || price <= 0) ? "Giá sản phẩm phải lớn hơn 0" : ''}
                    />
                    {readyToValidate && (!Utils.isValid(price) || price <= 0) && <div className="invalid-feedback d-block mt-1">Giá sản phẩm phải lớn hơn 0</div>}
                </div>
                <div className="col-md-3 mb-4 px-2">
                    {UIHelper.buildFormLabel('Giá gốc / giá niêm yết')}
                    <KTFormInput
                        type={KTFormInputType.currency}
                        unit='VNĐ'
                        placeholder="Nhập giá gốc để hiển thị gạch ngang"
                        name="originalPrice"
                        value={originalPrice}
                        onChange={(value) => {
                            setOriginalPrice(value);
                        }}
                        enableCheckValid={false}
                    />
                </div>
                <div className="col-md-3 mb-4 px-2">
                    {UIHelper.buildFormLabel('Hoa hồng affiliate (%)')}
                    <KTFormInput
                        type={KTFormInputType.number}
                        unit="%"
                        placeholder="VD: 7"
                        name="commissionRate"
                        value={commissionRate}
                        onChange={(value) => {
                            setCommissionRate(value);
                        }}
                        enableCheckValid={false}
                    />
                </div>
                {/* unit */}
                <div className="col-md-3 mb-4 px-2">
                    {UIHelper.buildFormLabel('Đơn vị tính', true)}
                    <KTBSDropdown
                        toggleElement={({ showError }) => (
                            <button
                                className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between ${showError ? 'button-invalid' : ''}`}
                                type="button"
                            >
                                {_.find(
                                    ChargeHelper.Data.inventoryUnitOptions,
                                    (item) => item.value === unit
                                )?.name ?? 'Chọn đơn vị tính'}
                            </button>
                        )}
                        selectedValue={unit}
                        dropdownMenuItems={ChargeHelper.Data.inventoryUnitOptions}
                        dropdownMenuStyle={{ maxHeight: '30vh' }}
                        dropdownMenuClassName="overflow-auto w-100"
                        onChange={(value) => setUnit(value)}
                        enableCheckValid
                        isDropdownForm={true}
                        isValid={Utils.isValid(unit)}
                        isTouched={readyToValidate}
                        feedbackText={readyToValidate && !Utils.isValid(unit) ? "Đơn vị tính không hợp lệ" : ''}
                    />
                    {readyToValidate && !Utils.isValid(unit) && <div className="invalid-feedback d-block mt-1">Vui lòng chọn đơn vị tính</div>}
                </div>

                {/* 4. Description Section */}
                <div className="col-12 mb-3 mt-2 px-2">
                    <div className="font-weight-bold d-flex align-items-center gap-2" style={{ fontSize: 16 }}>
                        <i className="fa-solid fa-align-left text-primary" /> Mô tả chi tiết <span className="text-danger">*</span>
                    </div>
                </div>
                {/* description */}
                <div className="col-md-12 mb-4 px-2">
                    <KTFormRichTextEditor
                        name="description"
                        data={description || ''}
                        variant="default"
                        minHeight={240}
                        placeholder="Nhập mô tả sản phẩm, ưu điểm, hướng dẫn sử dụng..."
                        editorConfig={defaultEditorConfig}
                        onChange={(value) => {
                            setDescription(value);
                        }}
                        fieldMeta={readyToValidate && !Utils.isValid(description) ? { error: 'Vui lòng nhập mô tả chi tiết', touched: true } : {}}
                    />
                </div>

                {/* 5. Custom Attributes Section */}
                <div className="col-12 mb-3 mt-2 px-2">
                    <div className="font-weight-bold d-flex align-items-center justify-content-between w-100" style={{ fontSize: 16 }}>
                        <span className="d-flex align-items-center gap-2">
                            <i className="fa-solid fa-list-check text-primary" /> Thuộc tính hiển thị cho khách hàng
                        </span>
                        <button type="button" className="btn btn-sm btn-light-primary" onClick={addAttribute}>
                            <i className="fa-solid fa-plus" /> Thêm thuộc tính
                        </button>
                    </div>
                </div>
                <div className="col-12 px-2 mb-4">
                    {(productAttributes || []).map((attribute, index) => (
                        <div
                            key={index}
                            className={`row m-0 p-0 mb-3 align-items-center ${draggedIndex === index ? 'opacity-50' : ''}`}
                            draggable
                            onDragStart={(e) => handleDragStart(e, index)}
                            onDragOver={(e) => handleDragOver(e, index)}
                            onDragEnd={handleDragEnd}
                        >
                            <div className="col-auto pl-0 pr-2 d-flex align-items-center" style={{ cursor: 'grab' }}>
                                <i className="fa-solid fa-grip-vertical text-muted" style={{ fontSize: '1.2rem' }} />
                            </div>
                            <div className="col pl-0 pr-2">
                                <input
                                    className="form-control"
                                    placeholder="Tên thuộc tính, VD: Số cổng"
                                    value={attribute.label}
                                    onChange={(event) => updateAttribute(index, 'label', event.target.value)}
                                />
                            </div>
                            <div className="col px-2">
                                <input
                                    className="form-control"
                                    placeholder="Giá trị, VD: 4 cổng"
                                    value={attribute.value}
                                    onChange={(event) => updateAttribute(index, 'value', event.target.value)}
                                />
                            </div>
                            <div className="col-auto pr-0 pl-2 d-flex align-items-center">
                                <button type="button" className="btn btn-light-danger btn-sm" onClick={() => removeAttribute(index)}>
                                    <i className="fa-regular fa-trash-can" />
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* actions */}
            <div
                className="d-flex align-items-center justify-content-end gap-3 px-4 py-3 bg-white mt-auto flex-shrink-0"
                style={{
                    borderTop: `1px solid ${AppColors.gray[200]}`,
                    borderBottomLeftRadius: '0.5rem',
                    borderBottomRightRadius: '0.5rem',
                }}
            >
                {UIHelper.buildNegativeButton('Hủy bỏ', onCancel, null)}
                {UIHelper.buildGreenButton(
                    !editMode ? 'Thêm' : 'Cập nhật',
                    handleSubmit,
                    null,
                    false,
                    loading
                )}
            </div>
        </div>
    );
}

export default DialogChargeInventoryAddView;
